<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
  name?: string
  id?: string
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})
</script>

<template>
  <input
    :name="name"
    :id="id"
    v-model="modelValue"
    :class="cn('flex h-10 w-full rounded-xl border border-gray-200 bg-background px-3 py-2 text-xs font-semibold ring-offset-background file:border-0 file:bg-transparent file:text-xs file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus:opacity-100 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50', props.class)"
  >
</template>
